var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-notes-detail',{staticClass:"pt-notes-detail__page",attrs:{"id":_vm.id,"signId":_vm.signId}})}
var staticRenderFns = []

export { render, staticRenderFns }